import { FC } from 'react'
import { fileReviewStateEnum } from '@/global/enum'
import style from './style.module.scss'

interface ContractTagProps {
  record: any
  onTagClick: (record: any, status: string) => void
}

const ContractTag: FC<ContractTagProps> = ({ record, onTagClick }) => {
  if (
    fileReviewStateEnum.isLabelIn(record.fileReviewState as any, ['未通过'])
  ) {
    return (
      <div
        className={style['contract-fail']}
        onClick={() => onTagClick(record, 'fail')}
      >
        未通过
      </div>
    )
  } else if (
    fileReviewStateEnum.isLabelIn(record.fileReviewState as any, ['审批中'])
  ) {
    return (
      <div
        className={style['contract-testing']}
        onClick={() => onTagClick(record, 'manReview')}
      >
        {record.fileReviewState}
      </div>
    )
  }

  return null
}

export default ContractTag
import { FC } from 'react'
import { fileReviewStateEnum } from '@/global/enum'
import style from './style.module.scss'

interface ContractTagProps {
  record: any
  onTagClick: (record: any, status: string) => void
}

const ContractTag: FC<ContractTagProps> = ({ record, onTagClick }) => {
  if (
    fileReviewStateEnum.isLabelIn(record.fileReviewState as any, ['未通过'])
  ) {
    return (
      <div
        className={style['contract-fail']}
        onClick={() => onTagClick(record, 'fail')}
      >
        未通过
      </div>
    )
  } else if (
    fileReviewStateEnum.isLabelIn(record.fileReviewState as any, ['审批中'])
  ) {
    return (
      <div
        className={style['contract-testing']}
        onClick={() => onTagClick(record, 'manReview')}
      >
        {record.fileReviewState}
      </div>
    )
  }

  return null
}

export default ContractTag
